(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    function rulaMeasureDropdown(event) {
  const item = event.target.closest?.('.header-menu .menu-list__list-item');
  if (!item || item.slot === 'overflow' || item.slot === 'more') return;
  const bounds = item.getBoundingClientRect();
  const space = window.innerWidth - bounds.left - 18;
  if (item.hasAttribute('data-rula-aligned-dropdown') || item.hasAttribute('data-rula-position-dropdown')) {
    const title = item.querySelector('.menu-list__link-title');
    if (title) item.style.setProperty('--rula-dropdown-top', (title.getBoundingClientRect().bottom - bounds.top + 8) + 'px');
  }
  item.style.setProperty('--rula-dropdown-space', Math.max(180, space) + 'px');
}
document.addEventListener('pointerover', rulaMeasureDropdown);
document.addEventListener('focusin', rulaMeasureDropdown);
window.addEventListener('resize', () => {
  document.querySelectorAll('.header-menu .menu-list__list-item').forEach(item => rulaMeasureDropdown({target:item}));
});
  } catch(e) { console.error(e); }
})();

})();
